import { buildPath } from '#app/lib/location'
import { truncateDecimals } from '#map/lib/geo'

export default {
  searchByPosition (base, bbox) {
    return buildPath(base, {
      action: 'search-by-position',
      // don't let buildPath do the bbox stringification
      // as it would uses a simple bbox.toString() and lose the []
      bbox: JSON.stringify(bbox.map(truncateDecimals)),
    })
  },
}
